module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_02c.a1065a5e.jpg";